import React, { Component } from "react";

import Base from "../../components/Base";

import queryString from "query-string";
import api from "../../services/api";
import handleError from "../../services/apiErrorHandler";

import "./styles.css";
import { Spin, Alert, Table, Button, Row, Col } from "antd";

export default class Atividades extends Component {
  /**
   * Lista de atividades do usuário no sistema
   */
  state = {
    loading: true,
    error: null,
    atividades: null,
    pagination: null,
    table_columns: [
      {
        title: "Data de solicitação",
        dataIndex: "dsolicitacao",
        key: "dsolicitacao"
      },
      {
        title: "Descrição",
        dataIndex: "desc",
        key: "desc"
      },
      {
        title: "Data de início",
        dataIndex: "dinicio",
        key: "dinicio"
      },
      {
        title: "Data de término",
        dataIndex: "dtermino",
        key: "dtermino"
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status"
      },
      {
        title: "Resultado",
        dataIndex: "resultado",
        key: "resultado"
      }
    ]
  };

  /** Monta a URL para download de arquivos direto da API */
  handleFileUrl = file => {
    let array = file.split("/");
    let filename = array[array.length - 1];
    return `${process.env.REACT_APP_API_URL}/media/relatorios/saida/${filename}`;
  };

  handleUploadActivities = async () => {
    /** Obtém as atividades e monta a tabela */

    this.setState({
      loading: true
    });

    /** Verifica se está paginado */
    const page = queryString.parse(this.props.location.search);
    let page_param = "";

    if (page.page) page_param = `?page=${page.page}`;

    await api
      .get(`/atividades/${page_param}`)
      .then(response => {
        const total = response.data.count;
        const results = response.data.results;

        const status_choices = {
          "0": "Aguardando",
          "1": "Processado",
          "2": "Processando",
          "3": "ERRO"
        };

        const data = [];

        if (results) {
          results.map(value => {
            let data_criacao = new Date(value.data_criacao).toLocaleString();
            let data_inicio = value.data_inicio
              ? new Date(value.data_inicio).toLocaleString()
              : "---";
            let data_fim = value.data_fim
              ? new Date(value.data_fim).toLocaleString()
              : "---";

            data.push({
              key: value.id,
              dsolicitacao: data_criacao,
              desc: value.descricao,
              dinicio: data_inicio,
              dtermino: data_fim,
              status: <b>{status_choices[value.status]}</b>,
              resultado: value.saida ? (
                <a target="__blank" href={this.handleFileUrl(value.saida)}>
                  <Button type="primary" key={value.id}>
                    Baixar
                  </Button>
                </a>
              ) : (
                <Button type="primary" disabled={true} key={value.id}>
                  Baixar
                </Button>
              )
            });
          });
        }

        this.setState({
          atividades: (
            <Table
              columns={this.state.table_columns}
              locale={{ emptyText: "Sem atividades" }}
              dataSource={data}
              pagination={{
                current: page.page ? parseInt(page.page) : 1,
                pageSize: 20,
                total: total,
                onChange: page => (window.location.href = `?page=${page}`)
              }}
            />
          )
        });
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 404) {
            window.location.href = "/atividades";
            return;
          }
          if (error.response.status == 401) {
            handleError(error);
            return;
          }
        }
        this.setState({
          error: "Não foi possível consultar suas atividades."
        });
      });

    this.setState({
      loading: false
    });
  };

  /** On page load */
  componentDidMount() {
    this.handleUploadActivities();
  }

  render() {
    let component = null;

    if (this.state.loading)
      component = (
        <div style={{ textAlign: "center" }}>
          <Spin />
        </div>
      );

    if (this.state.error)
      component = <Alert type="error" message={this.state.error} />;

    if (this.state.atividades) component = this.state.atividades;

    return (
      <Base
        title="Atividades"
        subTitle="Suas atividades solicitadas ao sistema"
        extra={[
          <Button key={1} type="primary" onClick={this.handleUploadActivities}>
            Atualizar
          </Button>
        ]}
      >
        {component}
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Atividades/index.js